/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_H2Inputs */

const en_viewer_ref_h2 = /** @type {(inputs: Viewer_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type shown`)
};

const ko_viewer_ref_h2 = /** @type {(inputs: Viewer_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표시되는 타입`)
};

const ja_viewer_ref_h2 = /** @type {(inputs: Viewer_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示される型`)
};

/**
* | output |
* | --- |
* | "Type shown" |
*
* @param {Viewer_Ref_H2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_h2 = /** @type {((inputs?: Viewer_Ref_H2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_H2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_h2(inputs)
	if (locale === "ko") return ko_viewer_ref_h2(inputs)
	return ja_viewer_ref_h2(inputs)
});